<template>
    <div id="playerCanvas" :class="playerClasses">

        <tracking v-if="consent"></tracking>
        <!-- <skin></skin> -->
        <break-ad v-if="breakAdActive"></break-ad>
        <fsk-overlay></fsk-overlay>

        <router-view class="playerContainer" v-show="!error" v-if="consent && adDynamicsReady"/>

        <div v-if="error" class="playerStandIn">
            <div class="content">
                <div>
                    <span>{{ errorMsg }}</span>
                </div>
                <div v-if="!consent">
                    <span>Hier gelangen Sie zu unseren <a href="https://www.rtl2.de/datenschutz" target="_top">Datenschutzeinstellungen</a></span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Tracking from './components/tracking/Tracking.vue'
// import Skin from './components/skins/SkinRTL2.vue'
import BreakAd from './components/ads/BreakAd.vue'
import FSKOverlay from "./components/overlays/FSKOverlay";

export default {
    name: 'PlayerCanvas',

    components: {
        Tracking,
        // Skin,
        BreakAd,
        'fsk-overlay': FSKOverlay,
    },

    data() {
        return {
            consent: false,
            adDynamicsReady: false,
            error: false,
            errorMsg: 'no error',
            breakAdActive: false,
            fskOverlayVisible: false,
        }
    },

    watch: {
        '$route.query'(query) {
            if (query && query.cbin) {
                this.$router.push({name: 'BobyConnect Player', params: {videoCbinId: query.cbin}})
            }
        }
    },

    mounted() {

        var vm = this;

        // JWPlayer consent
        this.$manager.vendorGrant('5edcd36411c0f85a57add03b').then(function (grants) {
            if (grants) {
                vm.consent = true;
            } else {
                vm.$l.log('JWPLAYER NOT granted by consent tool (vendorGrant)')
                vm.errorMsg = "Das Video kann aufgrund Ihrer aktuellen Datenschutzeinstellungen nicht wiedergegeben werden."
                vm.error = true;
            }
        })

        // JWPlayer consent
        this.$videoAdSchedule.getAdDynamics().then(function (adDynamics) {
            if (adDynamics) {
                vm.$l.log('JWPLAYER GOT adDynamics')
                vm.adDynamicsReady = true;
            } else {
                vm.$l.log('JWPLAYER adDynamics NOT received?')
                vm.adDynamicsReady = true;
            }
        })

        this.$nextTick(function () {

            var vm = this;

            if (this.$manager.get('breakad')) {
                this.breakAdActive = true
            }

            if (this.$manager.get('holaspark.active')) {

                // hola spark consent
                this.$manager.vendorGrant('5ef4bb9089849115596a6ab2').then(function (grants) {
                    if (grants) {
                        vm.$l.log('HOLASPARK gagranted by consent tool (vendorGrant)')
                        vm.$manager.whenExperiment("hola").then(function(shouldLoad) {
                            if(shouldLoad) {
                                vm.$l.log('HOLASPARK should load')
                                vm.loadHolaSpark(vm.$settings.holaspark.script);
                            }
                            else {
                                vm.$l.log('HOLASPARK should not load - Experiment Treatment')
                            }
                        }).catch(function(e){
                            vm.$l.log('HOLASPARK EXPERIMENT ERROR',e)
                            vm.$l.log('HOLASPARK should load')
                            vm.loadHolaSpark(vm.$settings.holaspark.script);
                        })

                    } else {
                        vm.$l.log('HOLASPARK NOT granted by consent tool (vendorGrant)')
                    }

                })

            }

        });

    },

    methods: {
        loadHolaSpark(scriptUrl) {

            var a, m

            a = document.createElement('script'), m = document.getElementsByTagName('script')[0];
            a.async = 1;
            a.crossOrigin = "anonymous";
            a.src = scriptUrl;
            m.parentNode.insertBefore(a, m)
        }
    },

    computed: {
        playerClasses() {
            return {
                'fskOverlayVisible': this.fskOverlayVisible
            }
        }
    },

    events: {

        fatalError(error) {

            this.$console.error('fatal error catched by playerCanvas', error)

            this.error = true
            this.errorMsg = error.msg
        },

        fskOverlayVisible(visible) {
            this.$l.log('fsk visible event!', visible);
            this.fskOverlayVisible = visible;
        },

        jwReady() {
            // disable JW Context Menu
            this.$jwplayer.getContainer().oncontextmenu = undefined;
        },

        jwAdBlock(evt) {
            if (this.$settings.detectAdBlocker) {
                this.error = true
                this.errorMsg = 'Bitte AdBlocker deaktivieren'
            }
        }
    }
}
</script>

<style lang="scss">

#playerCanvas {
    background: #000;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;

    display: flex;
    flex-direction: row;
    align-items: center;
}

.playerContainer, .playerStandIn {
    width: 100%;
}

.errormsg {
    color: red;
}

.playerStandIn {

    position: relative;
    background: #000;
    color: #fff;

    a, a:visited, a:active {
        color: #00b0e6;
    }

    &:before {
        display: block;
        content: "";
        width: 100%;
        padding-top: 9/16 * 100%;
    }

    > .content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        > * {
            padding: 10px;
        }

    }
}

.fskOverlayVisible .jw-title {
    width: 75%;
}

</style>



// WEBPACK FOOTER //
// src/PlayerCanvas.vue